<template>
  <div style="overflow: hidden;">
    <div :style="bgStyle" class="tabs-view">
      <div
        v-for="(item, index) in priceQeuryTypes"
        :key="index"
        :class="item.name == currentData.name ? 'selected' : ''"
        @click="changeTab(item)"
        class="tabs"
      >
        {{ item.name }}
      </div>
    </div>
    <ph-search v-model="searchWrold" :placeholder="'搜索'" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="height: calc(100% - 5.6rem);overflow: scroll"
    >
      <div v-for="(item, index) in list" :key="index" class="list-item">
        <div
          style="display: flex;justify-content: space-between;color: black;font-size: 1rem;"
        >
          <span>{{ item.name }}</span>
          <span>￥{{ item.price }}元/{{ item.unit }}</span>
        </div>
        <div>{{ item.remark }}</div>
        <!-- <div>
          {{ item.drugCompany }}
        </div> -->
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      currentPage: 1,
      finished: false,
      currentData: {},
      currentTab: "",
      searchWrold: "",
      bgStyle: {
        backgroundImage: `url(${require("@assets/bg_price_query.png")}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto"
      },
      priceQeuryTypes: [],
      list: [],
      clkType: ""
    };
  },
  // computed: {
  //   getList() {
  //     const reg = new RegExp(this.searchWrold);
  //     const list = this.list.filter(item => {
  //       return reg.test(item.name);
  //     });
  //     return list;
  //   }
  // },
  watch: {
    searchWrold: {
      handler(e) {
        this.currentPage = 1
        this.finished = false
        this.list = []
        // this.getDataList()
      }
    }
  },
  created() {
    // this.getPriceQeuryTypes();
  },
  methods: {
    onLoad() {
      if(this.priceQeuryTypes.length) {
        (this.clkType != "change") && this.getDataList();
      } else {
        this.getPriceQeuryTypes();
      }
    },
    getPriceQeuryTypes() {
      this.$http.post(this.$api.REFRENCE_PRICE_QUERY_TYPE, {
        isNew: '1'
      }).then(res => {
        const { typeList, firstPriceList } = res;
        this.priceQeuryTypes = typeList.map(item => {
          return {
            name: item.name,
            typeCode: item.code
          };
        });
         this.currentData = this.priceQeuryTypes[0]
        this.getDataList()
        // this.list = firstPriceList;
      });
    },
    getDataList() {
      this.$http
        .post(this.$api.REFRENCE_PRICE_QUERY_DETAIL, {
          typeName: this.currentData.name,
          typeCode: this.currentData.typeCode,
          page: this.currentPage,
          isNew: '1',
          preName: this.searchWrold
        })
        .then(res => {
          if(res.length < 20) {
            this.finished = true
          }
          this.currentPage++;
          this.loading = false;
          this.list = this.list.concat(res);
          this.clkType = ""
        });
    },
    changeTab(item) {
      this.clkType = "change"
      this.list = []
      this.currentData = item
      this.currentPage = 1
      this.finished = false
      this.getDataList()
    }
  }
};
</script>

<style lang="less" scoped>
.tabs-view {
  display: flex;
  padding: 2rem 1rem;
  overflow-x: scroll;
  white-space: nowrap;

  .tabs {
    height: 1.5rem;
    padding: 0 1rem;
    color: white;
    text-align: center;
  }

  .selected {
    color: #5189f2;
    background: white;
    border-radius: 12px;
  }
}
.list-item {
  padding: 1rem;
  color: gray;
  border-bottom: 1px solid #f4f4f4;
}
</style>
